import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategoryGrid from './components/CategoryGrid';
import HotArticlesSection from './components/HotArticlesSection';
import CTASection from './components/CTASection';
import { OrganizationSchema, WebSiteSchema, WebPageSchema, FAQPageSchema } from '@/components/base/SchemaOrg';
import { faqData } from '@/mocks/homepage';

export default function Home() {
  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        title="每日大赛黑料网 - 网红塌房现场一手爆料"
        description="每日大赛黑料网提供每日大赛黑料官网入口与app下载，实时汇集网红塌房现场一手爆料，黑料每日更新，吃瓜爆料不停歇。"
        url="http://cgbast.cn/"
      />
      <FAQPageSchema questions={faqData} />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategoryGrid />
        <HotArticlesSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}